import { getApiUrl, apiHeaders, sendRequest } from './request'
import DeviceId from 'utils/detectDevice'
import { getCookie } from 'utils/cookie'
import { baseUrl, domainName } from 'utils/parseDomain'

type LoginType = 'email' | 'google'

type LoginPayload = {
  username: string
  password: string
  type: LoginType
}

type LoginResponse = {
  uid: string
  next_action: string
  session_id?: string | undefined
  domain?: string | undefined
  access_token?: string | undefined
  email_token?: string | undefined
}

type LoginSubmission = (
  username: string,
  password: string,
  type: LoginType,
  response: LoginResponse
) => void

const login = async (payload: LoginPayload) => {
  const apiUrl = getApiUrl('users/login')

  const headers = apiHeaders({
    'x-platform': DeviceId.isMobile() ? 'wap' : 'web',
    'Content-Type': 'application/json',
  })

  const data = getData(payload)

  return await sendRequest(apiUrl, 'POST', headers, data)
}

const getData = (payload: LoginPayload) => {
  return JSON.stringify({
    data: payload,
    metadata: {
      session_ptnr: getCookie('affiliate'),
      autologin_flag: false,
    },
  })
}

export const loginSubmission: LoginSubmission = (
  username,
  password,
  type,
  response
) => {
  const $form = document.createElement('form')
  $form.method = 'POST'
  $form.action = baseUrl + '/registration/user/login-submit'

  const formData = {
    email: username,
    password,
    response: JSON.stringify(response),
    type,
    autologin: 'Y',
    cmtdom: 'www.' + domainName,
  }

  for (const [key, value] of Object.entries(formData)) {
    const $input = document.createElement('input')
    $input.type = 'hidden'
    $input.name = key
    $input.value = value
    $form.appendChild($input)
  }

  document.body.appendChild($form)
  $form.submit()
}

export default login
